import {
  Configuration,
  ConfigurationParameters
} from '@/apis/cms/configuration';
import * as cmsApi from '@/apis/cms/api';
import { cmsClientOptions } from 'vue/types/vue';

export const DEFAULT_CMS_CLIENT_CONFIG = {
  apiKey: process.env.VUE_APP_CMS_API_KEY,
  basePath:
    process.env.VUE_APP_CMS_API_ENDPOINT +
    '/' +
    process.env.VUE_APP_CMS_API_VERSION
};

export default {
  install(Vue: any) {
    Vue.prototype.$cmsClient = async (
      options: cmsClientOptions = {
        configurationParameters: {} as ConfigurationParameters
      }
    ) => {
      const config = new Configuration({
        ...DEFAULT_CMS_CLIENT_CONFIG,
        ...options.configurationParameters
      });
      return {
        notice: new cmsApi.NoticeApi(config),
        tos: new cmsApi.TosApi(config),
        news: new cmsApi.NewsApi(config),
        productTag: new cmsApi.ProductTagApi(config),
        product: new cmsApi.ProductApi(config),
        docs: new cmsApi.DocsApi(config),
        tutorial: new cmsApi.TutorialApi(config)
      };
    };
  }
};
